<template>
    <!-- 1，包含popup 的图片列表，（右侧有增加功能） -->
    <div>
        <!-- 弹出对话框 -->
        <pop-up
            ref="popupRef"
            width="1200px"
            :disabled="false"
            custom-class="body-padding"
            :title="`选择${tipsText}`"
            @confirm="handleConfirm"
            @close="handleClose">
            <!--放到 trigger 插槽中的内容;插槽显示图片列表， -->
            <template v-if="!hiddenUpload" #trigger>
                <!-- 可拖拽 -->
                <draggable v-model="fileLists" @update="updateSort" class="image-content">
                    <div 
                    class="image-item"
                    v-for="(element,index) in fileLists"  :key="element"  @click="handlePreview(index,element)">
                        <div>
                        <!-- 带删除标志的容器 -->
                        <del-wrap @close="deleteImage(index)">
                            <file-item
                                :uri="element"
                                :file-size="size"
                                :type="type">
                            </file-item>
                        </del-wrap>
                        <!--
                        <div class="image-btns-content">
                            阻断冒泡 
                            <span @click.stop="showPopup(index)">修改</span>
                            <span @click="handlePreview(index,element)">查看</span>
                        </div>
                        -->
                        </div>
                    </div>
                </draggable>
                <!-- 增加按钮 -->
                <div @click="showPopup">
                    <!-- 图片列表右侧添加按钮 -->
                    <slot name="upload">
                        <div
                            class="upload-btn"
                            :style="{
                                width: size,
                                height: size
                            }"
                        >
                            <icon :size="36" name="el-icon-circle-plus-outline" />
                            <span>添加</span>
                        </div>
                    </slot>
                </div>
            </template>

            <!-- 放在默认插槽的内容 -->
            <!-- <el-scrollbar> -->
                <div class="image-item">
                    <material
                        ref="materialRef"
                        mode="picker"
                        :type="type"
                        :file-size="fileSize"
                        :limit="meterialLimit"
                        @change="selectChange"
                    />
                </div>
            <!-- </el-scrollbar> -->
        </pop-up>
        <!-- 弹出预览 -->
        <preview v-model="showPreview" v-bind:url="previewUrls" v-bind:type="type">
        </preview>
    </div>
</template>

<script>
import FileItem from './fileitem.vue' // 文件组件
import Draggable from 'vuedraggable'// 拖拽组件
import Material from './index.vue'//素材组件
import Preview from './preview'// 预览
import PopUp from '@/components/PopUp/index.vue'//弹出框，对dialog封装
import DelWrap from '@/components/DelWrap' // 带删除的容器
import Icon from '@/components/Icon'

export default {
    components:{Preview,Material,PopUp,DelWrap,Draggable,FileItem,Icon, Preview},
    // v-model 的value 和事件
    model: {
        prop: 'value',
        event: 'change'
    },
    
    props:{
        //传递过来的文件列表,用于v-model
        value:{
            type: [String, Array], //
            default: () => []
        },
        type:{ //文件类型
            type: String,
            default: 'image'
        },
         // 选择器尺寸
        size:{
            type: String,
            default: '100px'
        },
        // 文件尺寸
        fileSize: {
            type: String,
            default: '100px'
        },
        // 选择数量限制
        limit: {
            type: Number,
            default: 1
        },
        // 隐藏上传框*(目前在富文本中使用到，类似封装一个dialog)
        hiddenUpload: {
            type: Boolean,
            default: false
        },
         //选择的url排出域名
        excludeDomain: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            fileLists:[],//文件列表
            showPreview:false,// 显示预览
            previewUrls:[],// 预览的图像列表
        }
    },
    created(){
      
    },
    computed:{
        tipsText:function(){
            switch (this.type) {
                case 'image':
                    return '图片'
                case 'video':
                    return '视频'
                default:
                    return ''
            }
        },
        //素材数量限制
        meterialLimit:function(){
        }
    },
    watch:{
        //观察Value是否改变
        value:{
            handler(newValue,oldValue){
                // 
                this.fileLists=Array.isArray(newValue) ? newValue : newValue == '' ? [] : [newValue]
            },
            immediate:true, //当 watch 一个变量的时候，初始化时并不会执行你需要在created的时候手动调用一次。添加immediate属性，这样初始化的时候也会触发
        }
    },
    methods:{
        // 弹出对话框的确认事件
        /**
         * 1,图像列表中所选择的数据进行更改
         */
        handleConfirm(){
          const selectData=this.$refs.materialRef.selectList;
          this.$refs.materialRef.selectList=[]; //把选择的置空
          // 通过遍历赋值
          for(let index in selectData){
            if(this.fileLists.indexOf(selectData[index].uri)==-1){
                this.fileLists.push(selectData[index].uri);
            }
          }
          this.handleChange();

        },
        //弹出对话框的关闭
        handleClose(){
            // this.fileLists=[];
            // material的Select 中的数据清空；
        },
        showPopup(){
            
            this.$refs.popupRef.open();
        },
        //删除图像
        deleteImage(index){
            this.fileLists.splice(index, 1);
            this.handleChange();
        },
        
        //改变
        handleChange(){
            // const valueImg = this.limit != 1 ? this.fileLists : this.fileLists[0] || ''
            const valueImg=this.fileLists;
            this.$emit('update:value', valueImg)// v-bind：ysnc 时候用 
        
            this.$emit('change', valueImg) //子组件更新父组件值（v-model 语法糖）
        },
        selectChange(value){
            // this.select=value;
        },

        // 更新顺序
        updateSort(){
            const sortedList = this.fileLists.map(function (value, index) {
                return value; 
            })
            this.fileLists=sortedList;
            this.handleChange();
        },
        //预览图像
        handlePreview(paraIndex,paraItem){
           
            var arrayTemp=[];
            if(paraIndex>0){
                for(let i=paraIndex;i<this.fileLists.length;i++){
                arrayTemp.push(this.fileLists[i]) 
                }
                for(let i=0;i<paraIndex;i++){
                    arrayTemp.push(this.fileLists[i]) 
                }
            }else{
                arrayTemp=this.fileLists;
            }
            
            this.previewUrls=arrayTemp;
            this.showPreview=true;
        }
    }
}
</script>

<style scoped>
.image-content{
    display: flex;
    flex-direction: row;
    flex-wrap:wrap;
}
.image-item{
    margin-top: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    flex-wrap:wrap;
    border-radius: 4px;
    cursor: pointer;
    /* float: left; */
}

.image-btns-content{
    display: flex;
    justify-content:space-around;
}
.upload-btn{
    display: flex;
    justify-content:center;/**水平居中 */
    align-items:center;/*垂直居中 */
    border-style: solid;
    border-width: 1px;
    border-radius:5px;
}
</style>